// Vehicle data from content/vehicles.csv - images at /vehicle-images/{folder}/1.jpg
export const vehicles = [
  {
    folder: "toyota-4runner-2019",
    year: 2019,
    brand: "Toyota",
    type: "4Runner 4.0 SR5",
    armor: "CEN B6",
    price: 59995,
    specs: [
      "60,000 km (low mileage)",
      "CEN B6 armor protection (assault rifle proof)",
      "4.0L V6 engine - proven reliability",
      "Excellent condition, ready for export",
      "Popular choice for executive transport",
      "Located in Colombia, ready to ship",
    ],
    mileage: 60000,
  },
  {
    folder: "toyota-landcruiser-2014",
    year: 2014,
    brand: "Toyota",
    type: "Land Cruiser 4.5 Imperial LC200",
    armor: "CEN B6",
    price: 61500,
    specs: [
      "122,500 km - excellent condition",
      "4.5L V8 gasoline engine",
      "CEN B6 armor protection (assault rifle proof)",
      "Imperial trim level - premium features",
      "Most popular armored SUV worldwide",
      "Ready for immediate export",
    ],
    mileage: 122500,
  },
  {
    folder: "toyota-tundra",
    year: null,
    brand: "Toyota",
    type: "Tundra 5.7 Crewmax Platinum",
    armor: "CEN B6",
    price: 71500,
    specs: [
      "70,000 km - low mileage for year",
      "5.7L V8 engine - maximum power",
      "Crewmax cabin - spacious crew seating",
      "Platinum trim - premium luxury features",
      "CEN B6 armor protection (assault rifle proof)",
      "Ideal for commercial & security use",
    ],
    mileage: 70000,
  },
  {
    folder: "toyota-corolla-2019",
    year: 2019,
    brand: "Toyota",
    type: "Corolla 1.8 SE-G Hybrid",
    armor: "CEN B6",
    price: 42500,
    specs: [
      "32,500 km - extremely low mileage",
      "1.8L Hybrid engine - fuel efficient",
      "SE-G trim - premium sedan features",
      "CEN B6 armor protection (assault rifle proof)",
      "Perfect for discreet executive transport",
      "Most affordable armored option",
    ],
    mileage: 32500,
  },
  {
    folder: "toyota-sequoia-2024",
    year: 2024,
    brand: "Toyota",
    type: "Sequoia 3.5 V6 Capstone",
    armor: "CEN B6",
    price: 175000,
    specs: [
      "4,000 km - virtually brand new",
      "3.5L Twin-Turbo V6 hybrid engine",
      "Capstone trim - ultimate luxury package",
      "Latest 2024 model year",
      "CEN B6 armor protection (assault rifle proof)",
      "Full-size 3-row luxury SUV",
    ],
    mileage: 4000,
  },
  {
    folder: "volkswagen-golf-2019",
    year: 2019,
    brand: "Volkswagen",
    type: "Golf VII 2.0 GTI Performance",
    armor: "CEN B6",
    price: 31500,
    specs: [
      "82,000 km - well maintained",
      "2.0L Turbo engine with DSG transmission",
      "Performance package - enhanced handling",
      "Most affordable option available",
      "CEN B6 armor protection (assault rifle proof)",
      "Perfect for ultra-discreet operations",
    ],
    mileage: 82000,
  },
];
